import { Link, useSearchParams } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const isPlan = params.get("kind") === "fiver";
  return (
    <div className="max-w-lg mx-auto px-4 py-16">
      <Card className="border-slate-200 shadow-lg">
        <CardContent className="py-10 text-center space-y-4">
          <XCircle className="w-14 h-14 mx-auto text-amber-600" />
          <h1 className="font-display text-2xl font-bold" data-testid="payment-cancel-title">{isPlan ? "Fiver Deal sign-up cancelled" : "Payment cancelled"}</h1>
          <p className="text-slate-600">{isPlan ? "No worries — nothing was set up and your card wasn't saved. You can join any time from your dashboard." : "No worries — nothing was charged. You can try again anytime."}</p>
          <Link to="/dashboard"><Button className="bg-emerald-800 hover:bg-emerald-900">Back to dashboard</Button></Link>
        </CardContent>
      </Card>
    </div>
  );
}
